export enum FBEInstallStatus {
  NOT_INSTALLED = 'NOT_INSTALLED',
  INSTALLED = 'INSTALLED',
  PENDING = 'PENDING',
  INSTALLING = 'INSTALLING',
  UNINSTALLING = 'UNINSTALLING',
}
